<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header style="padding:2rem 1rem 0rem 1rem;">
      <div>已选物资：{{form.piece}}</div>
    </zj-layout-header>
    <zj-layout-main style="padding:1rem 1rem;">
      <zj-layout-container>
        <zj-layout-main style="padding:0px 0px;">
          <el-table :data="gridData" height="100%" max-height="27rem" style="min-height:27rem;">
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column property="name" label="物资名称"></el-table-column>
            <el-table-column property="materialType" label="物资类型" :formatter="materialType" align="center">
              <template slot-scope="scope">
                <span v-for="item in options" :key="item.id">
                  <span v-if="item.code == scope.row.materialType">{{ item.value }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column property="stock" label="现库存" align="center"></el-table-column>
          </el-table>
        </zj-layout-main>
        <zj-layout-footer style="padding:1rem 0px;">
          <el-divider></el-divider>
          <el-form :model="form" class="zj-search-form" label-width="8rem" style="margin-top:4rem;" :rules="rules">
            <el-form-item label="入库数量" style="display:inline-block;">
              <el-input-number style="width:50rem;" v-model="form.operationNum" autocomplete="off" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="领取人" style="display:inline-block;" prop="person">
              <el-input style="width:50rem;" v-model="form.person"></el-input>
            </el-form-item>
            <el-form-item label="入库日期" style="display:inline-block;">
              <el-date-picker
                type="datetime"
                placeholder="选择日期"
                v-model="form.InDate"
                style="width:50rem;"
                :clearable="false"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </zj-layout-footer>
      </zj-layout-container>
    </zj-layout-main>
    <zj-layout-footer style="text-align:center;">
      <el-button @click="onBack()">取消</el-button>
      <el-button @click="submitForm()">确定</el-button>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import { getDictionary } from '@/api/src/emergency_common'
import { materialInoutBatchSave } from '@/api/src/emergency_materialInout'
export default {
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      gridData: [],
      form: {
        piece: "（共0条）",
        operationNum:1,
        InDate: "",
        person:""
      },
      rules: {
        person: [
          { required: true, message: "请输入领取人", trigger: "blur" }
        ]
      },
      options: [],
      pickerOptions: { // 限制收货时间不让选择今天以前的
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      }
    };
  },
  props: {
    viewData: Object,
    materialTypedate:Object
  },
  created () {
    this.form.person = this.user.DisplayName;
    this.form.InDate = this.getDayTimer();
  },
  mounted: function() {
    this.basedatabind();
    var selectData = this.viewData;
    this.form.piece = "（共"+selectData.length+"条）";
    this.gridData = selectData;
  },
  methods: {
    basedatabind() {
      getDictionary('emergency_material_type')
        .then(res => {
          //物资类型
          this.options = res.data.records;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    //取消按钮
    onBack() {
      this.$emit("cancel", {});
    },
    //确定按钮
    submitForm() {
      const datalist = []
      this.viewData.forEach(item => {
        datalist.push({
          belongEnterprise: item.belongEnterprise,
          createdate: item.createdate,
          materialId: item.id,
          modifydate: item.modifydate,
          warehouseId: item.warehouseId
        })
      })
      datalist.forEach(item => {
        item.type = 2 // 出库
        item.operationNum = parseInt(this.form.operationNum);
        item.operationDate = this.form.InDate
        item.receiver = this.form.person
        item.operationPerson = this.user.DisplayName
      });
      this.loading = true;
      this.loadingText = '保存中...';
      materialInoutBatchSave(datalist)
        .then(r => {
          if (r) {
            this.$message({
              type: "success",
              message: "入库成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: "入库失败!"
            });
          }
          this.logInfo.ActionName = "应急物资入库";
          this.logInfo.LogMessage = r ? "应急物资入库成功" : "应急物资入库失败";
          this.logInfo.ModuleName = "应急系统";
          this.logInfo.PageName = "应急物资管理";
          this.addOperationLog();
          this.$emit("search", {});
          this.$emit("ok", {});
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    getDayTimer () {
      var date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var currentdate = y + '-' + m + '-' + d;
      var hh = date.getHours()
      hh = hh < 10 ? ('0' + hh) : hh
      var mm = date.getMinutes()
      mm = mm < 10 ? ('0' + mm) : mm
      var ss = date.getSeconds()
      ss = ss < 10 ? ('0' + ss) : ss
      var time = hh + ':' + mm + ':' + ss;
      return currentdate + " " + time
    }
  }
};
</script>
<style lang="scss" scoped>
.zj-layout-container .zj-layout-main .zj-table-container {
    margin-top: 0.8rem;
    margin-bottom: 1rem;
    flex: 1 1 auto;
    overflow: auto;
    overflow-x:hidden;
    max-height: 30rem;
  }
</style>